import { render, staticRenderFns } from "./safety-inspection.vue?vue&type=template&id=3fe11574&scoped=true&"
import script from "./safety-inspection.vue?vue&type=script&lang=js&"
export * from "./safety-inspection.vue?vue&type=script&lang=js&"
import style0 from "./safety-inspection.vue?vue&type=style&index=0&id=3fe11574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe11574",
  null
  
)

export default component.exports